export class GcpCloudSqlResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "engine",
            "baseName": "engine",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineVersion",
            "baseName": "engineVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageSettings",
            "baseName": "storageSettings",
            "type": "GcpCloudSqlResourceStorageSettings",
            "format": ""
        },
        {
            "name": "instanceTier",
            "baseName": "instanceTier",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpCloudSqlResource.attributeTypeMap;
    }
    constructor() {
    }
}
